import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { BotIcon, MessageSquareIcon, ZapIcon } from 'lucide-react';
import { SlackPanel } from './SlackIntegrationGraph';
const BACKGROUND_VIDEO_URL = "/download (11).mp4";
const BENEFITS = [{
  icon: BotIcon,
  title: 'A teammate in the thread',
  description: 'Giga brings the relevant history, decisions, and source material into the conversation when your team needs it.'
}, {
  icon: ZapIcon,
  title: 'Work keeps moving',
  description: 'Turn a request into a finished brief, update, or follow-up without losing the context that got you there.'
}, {
  icon: MessageSquareIcon,
  title: 'Everyone stays aligned',
  description: 'The answer, the work, and the next step live together—so the whole team can move with confidence.'
}];
export function TeamSlackWorkspace() {
  const reducedMotion = !!useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-[#FAF8F4] py-24 text-[#2B211A] md:py-32" data-id="element-5997" data-mp="3tr9i4avoc0x9">
      <div className="relative mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-14 px-6 md:px-10 lg:grid-cols-[minmax(0,0.76fr)_minmax(0,1.24fr)] lg:gap-20" data-id="element-5998" data-mp="1aaccmsk311gs">
        <motion.div initial={reducedMotion ? false : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-xl" data-id="element-5999" data-mp="1f2vtpzhzaeqc">
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.24em] text-[#EA580C] md:text-sm" data-id="element-6000" data-mp="1xzn5zoz3rtkw">
            Collaborate in Slack
          </p>
          <h2 className="mt-6 font-medium tracking-[-0.045em] text-[#2B211A] sm:text-5xl md:text-6xl text-[48px]" data-id="element-6001" data-mp="1jzceqktvscz7">
            Shared context, right in the conversation.
          </h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-[#6B5D52] md:text-xl" data-id="element-6002" data-mp="8jxl9r0vs38u">
            Giga keeps the team&apos;s work connected where decisions are
            already happening—without another place to check.
          </p>

          <div className="mt-10 space-y-7 md:mt-12" data-id="element-6003" data-mp="2fatu2yxtt2df">
            {BENEFITS.map((benefit, index) => {
            const Icon = benefit.icon;
            return <motion.div key={benefit.title} initial={reducedMotion ? false : {
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.35
            }} transition={{
              duration: 0.45,
              delay: reducedMotion ? 0 : 0.12 + index * 0.1,
              ease: [0.22, 1, 0.36, 1]
            }} className="flex items-start gap-4" data-id="element-6004" data-mp="25i4nahd80cof" data-mpi={index}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-[#EA580C]/20 bg-[#FFF4EC] text-[#EA580C]" data-id="element-6005" data-mp="1hmac7p6plnuc">
                    <Icon size={20} strokeWidth={1.9} aria-hidden="true" data-id="element-6006" data-mp="3gvyvyd9pkhu4" />
                  </span>
                  <div data-id="element-6007" data-mp="3bxf8g8fguxzn">
                    <h3 className="text-xl font-semibold tracking-tight text-[#2B211A]" data-id="element-6008" data-mp="3kgsfluur0u22">
                      {benefit.title}
                    </h3>
                    <p className="mt-1.5 max-w-md text-base leading-relaxed text-[#6B5D52]" data-id="element-6009" data-mp="3og19r0tpaty5">
                      {benefit.description}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </motion.div>

        <motion.div initial={reducedMotion ? false : {
        opacity: 0,
        y: 24,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="w-full" data-id="element-6010" data-mp="31i6e4evbl0xm">
          <SlackPanel data-id="element-6011" data-mp="3fetaaffg7n2h" />
        </motion.div>
      </div>
    </section>;
}